import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomerInfo } from './../model/customer-info';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable()
export class CustomerInfoService {
    // public info: CustomerInfo

    public url: string = '../../../mocks/data.json';

    constructor(private http: HttpClient) {}

    getFraudDisclosure(): Observable<CustomerInfo[]> {
        return this.http.get<any>(this.url);
    }

    saveCustomerInfo(info: CustomerInfo): Observable<any> {
        return this.http.post<any>(this.url, info);
    }
}
